import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const Home = lazy(()=>import('../../components/HomeCompo/Home'))

const HomePage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <Home/>
            </Suspense>
        </Fragment>
    );
};

export default HomePage;